module.exports = "<app-datagrid [rowData]=\"models\" [columnDefs]=\"columns\" [sidebar]=\"sidebar\" [gridOptions]=\"gridOptions\"></app-datagrid>"